import { getPlanDetails } from "@/api/payment";
import { defineStore } from "pinia";

export const usePayment = defineStore("payment", {
  state: () => ({
    planDetails: {
      plan: 1,
      subscriber: 0,
      email_per_month: 0,
      payNow: 0,
      email_per_day: 0,
      can_renew: 0,
      contact_support: 0,
      plan_type: 1,
      plan_amount: 0,
      expire: 0,
      currentSubscriber: 0,
      groupOf: 0,
      planTitle: "",
      enterpricePlan: 0,
      newPlan: {
        plan: 0,
      },
      currency: "usd",
    },
    planLoaded: false,
  }),
  actions: {
    getPlanDetails(params) {
      getPlanDetails(params).then(({ data }) => {
        this.planDetails = data;
        window.localStorage.setItem(
          "duplicateContactAllowedClient",
          data.allowDuplicateContacts
        );
        this.planLoaded = true;
      });
    },
  },
});
